import { 
  PRESUPUESTADOR_SELECT_TIPO_VENTA,
  PRESUPUESTADOR_SELECT_STOCK
} from './constants'

export function selectTipoVenta(tipo) {
  return (dispatch, getState) => {
    const { presupuestador } = getState()

    let entregaUsados = []
  
    if (presupuestador.entregaUsados?.length > 0) {
      entregaUsados = presupuestador.entregaUsados.map(usado => {
          usado.take_improvement_amount = 0;
          usado.final_take_price = usado.updatedTakePrice || usado.original_price;
          return usado;
      });
    }

    dispatch({
      type: PRESUPUESTADOR_SELECT_TIPO_VENTA,
      data: {
        tipoVentaSelected: tipo,
        selectedLineaFinanciera: null,
        special_discount: 0,
        entregaUsados,
        // tipo de vta. directa no lleva bonif. por concesionario, se friza para recuperarlas cuando cambia el tipo de vta.
        nuevo: tipo === "venta_directa" ? {
          ...presupuestador.nuevo,
          bonification: {
            ...presupuestador?.nuevo?.bonification,
            car_lot_amount: null, 
            car_lot_amount_friz: presupuestador?.nuevo?.bonification?.car_lot_amount, 
          }
        } : {
          ...presupuestador.nuevo,
          bonification: {
            ...presupuestador?.nuevo?.bonification,
            car_lot_amount: presupuestador?.nuevo?.bonification?.car_lot_amount_friz || presupuestador?.nuevo?.bonification?.car_lot_amount,
          }
        },
        // volver al valor por defecto de una unidad al cambiar tipo de venta
        sumarCantidad: 1
      },
    })

    if(tipo === "venta_directa") {
      //borro stock seleccionado si cambia a directa
      dispatch({
        type: PRESUPUESTADOR_SELECT_STOCK,
        data: {
          selectedStock: null,
          stock_id: null,
          stock_color: null,
          stock_ubicacion: null,
          stock_vin: null,
          stock_sucursal: null,
          stock_estado: null,
        },
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SELECT_TIPO_VENTA:
      return {
        ...state,
        ...action.data
      }

    default:
      return state
  }
}
